import React from 'react';
import { TrendingUp, Globe2, Landmark, Plane } from 'lucide-react';
export function GrowthContext() {
  return <section className="py-12 md:py-16 bg-emerald-600 text-white relative overflow-hidden" data-id="element-97">
      <div className="absolute top-0 left-0 w-full h-1 flex" data-id="element-98">
        <div className="flex-1 bg-[#008C45]" data-id="element-99" />
        <div className="flex-1 bg-white" data-id="element-100" />
        <div className="flex-1 bg-[#CD212A]" data-id="element-101" />
      </div>

      <div className="container mx-auto px-4 max-w-4xl text-center relative z-10" data-id="element-102">
        <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-white/20 mb-4 md:mb-6" data-id="element-103">
          <TrendingUp className="w-6 h-6 md:w-8 md:h-8 text-white" data-id="element-104" />
        </div>
        <h2 className="font-display text-2xl md:text-4xl font-bold mb-4 md:mb-6" data-id="element-105">
          EL ITALIANO ESTÁ EN CRECIMIENTO
        </h2>
        <p className="text-base md:text-xl text-emerald-100 mb-6 md:mb-10" data-id="element-106">
          Cada vez más personas quieren aprender italiano por:
        </p>

        <div className="grid grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-12" data-id="element-107">
          <div className="bg-white/10 rounded-xl p-4 md:p-6 backdrop-blur-sm border border-white/20" data-id="element-108">
            <Landmark className="w-6 h-6 md:w-8 md:h-8 mx-auto mb-2 md:mb-3 text-emerald-200" data-id="element-109" />
            <h3 className="text-sm md:text-xl font-bold" data-id="element-110">Ciudadanía</h3>
          </div>
          <div className="bg-white/10 rounded-xl p-4 md:p-6 backdrop-blur-sm border border-white/20" data-id="element-111">
            <Plane className="w-6 h-6 md:w-8 md:h-8 mx-auto mb-2 md:mb-3 text-emerald-200" data-id="element-112" />
            <h3 className="text-sm md:text-xl font-bold" data-id="element-113">Viajes</h3>
          </div>
          <div className="bg-white/10 rounded-xl p-4 md:p-6 backdrop-blur-sm border border-white/20" data-id="element-114">
            <Globe2 className="w-6 h-6 md:w-8 md:h-8 mx-auto mb-2 md:mb-3 text-emerald-200" data-id="element-115" />
            <h3 className="text-sm md:text-xl font-bold" data-id="element-116">Cultura</h3>
          </div>
        </div>

        <p className="text-base md:text-2xl font-bold bg-white text-emerald-700 py-3 md:py-4 px-6 md:px-8 rounded-xl inline-block shadow-lg italic" data-id="element-117">
          "La demanda existe. La diferencia es cómo enseñás."
        </p>
      </div>
    </section>;
}